import { isDefined } from "@mapmycustomers/shared/util/assert";

import { ComposedViewContext, ViewContextEntry, ViewContextSegment } from "./ViewContextState";

type PageEntry = Extract<ViewContextEntry, { layer: "page" }>;
type RecordEntry = Extract<ViewContextEntry, { layer: "record" }>;

export const isPageEntry = (entry: ViewContextEntry): entry is PageEntry => entry.layer === "page";
const isRecordEntry = (entry: ViewContextEntry): entry is RecordEntry => entry.layer === "record";

const toRecordSegment = ({ label, record }: RecordEntry): ViewContextSegment => ({
  entityType: record.entityType,
  label,
  layer: "record",
});

// The one place that decides what the bar shows and what is sent: the page with its record on top.
const composeViewContext = (entries: ViewContextEntry[]): ComposedViewContext | undefined => {
  const page = entries.filter(isPageEntry).at(-1);
  const record = entries.filter(isRecordEntry).at(-1);

  if (!page) {
    return record
      ? {
          anchorKey: record.anchorKey,
          context: { record: record.record, screen: "record" },
          segments: [toRecordSegment(record)],
        }
      : undefined;
  }

  const pageSegment: ViewContextSegment = {
    entityType: page.context.screen === "list" ? page.context.entityType : undefined,
    label: page.label,
    layer: "page",
    screen: page.context.screen,
  };
  return {
    anchorKey: [page.anchorKey, record?.anchorKey].filter(isDefined).join("|"),
    context: { ...page.context, ...(record ? { record: record.record } : {}) },
    segments: record ? [pageSegment, toRecordSegment(record)] : [pageSegment],
  };
};

export default composeViewContext;
